﻿// Please see documentation at https://docs.microsoft.com/aspnet/core/client-side/bundling-and-minification
// for details on configuring this project to bundle and minify static web assets.

require('../css/global.css');
$ = require('jquery');
var mmsystem = mmsystem || {};
mmsystem.ui = mmsystem.ui || {};
mmsystem.utilities = require('mmsystem-utilities');
mmsystem.plugins = require('mmsystem-plugins');
mmsystem.ui.ajax = require('mmsystem-ui-ajax');
var jQueryValidation = require('jquery-validation');

window.mmsystem = mmsystem;

//app.js Marcelo's code start
var businesses = [
    {
        type: 'charter',
        data: {
            colors: {
                primary: '#071e57',
                secondary: '#00154a',
                arrow: '#5db2e3',
                text: '#fff;'
            },
            image: 'logo--charter.svg',
            alt: 'Academy charter bus',
            html: '<b>Convenient, affordable and safe way of transportation for group events and trips.</b><span>Whether you need to transport 20 or 20,000, our 1100 buses can deliver. From sightseeing tours to conventions, corporate transfers, sports teams, parades, major sporting events and private charters, Academy has the wheels and where withal to ensure the smoothest ride on the road. We know the way...</span>',
            website: 'www.academybuscharter.com'
        }
    },
    {
        type: 'commute',
        data: {
            colors: {
                primary: '#5db2e3',
                secondary: '#0090e3',
                arrow: '#fff',
                text: '#fff;'
            },
            image: 'logo--commuter.svg',
            alt: 'Academy bus',
            html: '<b>Relaxing commuter service to the New York, Baltimore and Washington DC areas.</b><br>We provide scheduled bus service for commuters traveling to and from work. Our buses are equipped with comfortable seating, air conditioning, and overhead luggage racks. Academy buses are a convenient, affordable and eco-friendly way of commuting to work or school.',
            website: 'www.academybus.com/commuter'
        }
    },
    {
        type: 'gobuses',
        data: {
            colors: {
                primary: '#efeeea',
                secondary: '#e0dbd1',
                arrow: '#5db2e3',
                text: '#00154a;'
            },
            image: 'logo--gobuses.svg',
            alt: 'Go Buses',
            html: '<b>Safe, quick and affordable bus service for the NorthEast.</b><br>Travel by bus between New York City, Boston and Northern Virginia on board Go Buses, an Academy Bus company. With convenient stops, competitive fares and top quality buses Go Buses is your inter-city transportation choice.',
            website: 'www.gobuses.com'
        }
    }
];

var images = [];

var timeline = [
    {
        year: '1930',
        content: '<h2>1930</h2><p>Pasquale Tedesco purchases bus 39 and operates along Broadway in Bayonne, NJ.</p>'
    },
    {
        year: '1968',
        content: '<h2>1968</h2><p>Academy is officially incorporated by Frank A.Tedesco.<br><br><img src="images/logos/academy--blue.JPG" alt="academy logo"></p>'
    },
    {
        year: '1969',
        content: '<h2>1969</h2><p>Academy Lines is formed with the purchase of the New York-Keansburg, Long Branch Bus Company and its ICC Certificate.</p>'
    },
    {
        year: '1970',
        content: '<h2>1970</h2><p>Academy moves out of Bayonne, NJ to its new home in Hoboken, NJ.</p>'
    },
    {
        year: '1980',
        content: '<h2>1980</h2><p>It was during this time that Academy experienced its most instrumental growth opening its Atlantic City Terminal as well as overhauling Secaucus facility.<br><br>Started Route 9 service to Downtown Manhattan (additional 60 buses).<br><br>ACQUISITIONS: ASBURY PARK TRANSIT RICCI BUS COMPANY BODY RITE REPAIR COMPANY.</p>'
    },
    {
        year: '1990',
        content: '<h2>1990-1994</h2><p>Hoboken garage and offices renovated and upgraded. A new dispatch building is constructed.<br><br>Leonardo garage undergoes extensive renovations. NEW Toms River Terminal opens replacing Lakewood.</p>'
    },
    {
        year: '1996',
        content: '<h2>1996-1997</h2><p>New office and expanded Pomona garage are built.<br><br>Academy opens Perth Amboy Terminal.</p>'
    },
    {
        year: '1998',
        content: '<h2>1998</h2><p>Academy Bus headquarters moves to 111 Paterson Avenue in Hoboken, NJ.<br><br>Academy takes over tarmac airport shuttle services for Continental Airlines.</p>'
    },
    {
        year: '1999',
        content: '<h2>1999</h2><p>Academy constructs NEW Perth Amboy garage.<br><br>Academy is awarded the Hudson, Middlesex and Plainfield contracts by New Jersey Transit.</p>'
    },
    {
        year: '2001',
        content: '<h2>2001</h2><p>Academy is awarded the Rutgers University shuttle bus contract and acquires 50 buses to operate this contract.</p>'
    },
    {
        year: '2003',
        content: '<h2>2003-2004</h2><p>Academy starts operating Route 9 to Midtown service in cooperation with New Jersey Transit (additional 32 buses).<br><br>Academy starts service from and builds Park & Ride in Jackson, NJ to Midtown and Downtown Manhattan.<br><br>Academy takes delivery of Mercedes Setra coaches. Introduces silver livery with black script logo.</p>'
    },
    {
        year: '2008',
        content: '<h2>2008</h2><p>Academy opens the Hoboken Annex Garage (30,000 square feet).<br><br>The New Westampton office and 525 car Park & Ride opens.</p>'
    },
    {
        year: '2009',
        content: '<h2>2009</h2><p>NEW Westampton garage opens.<br><br>Academy is awarded the Yale, Sacred Heart and Fairfield contracts.</p>'
    },
    {
        year: '2010',
        content: '<h2>2010</h2><p>Bridgeport Connecticut and Rhode Island terminals open.<br><br>Academy takes over Premiere Bus Lines in New York as well as Campus coaches.<br><br>ACQUISITION: ARCHWAY TOURS</p>'
    },
    {
        year: '2011',
        content: '<h2>2011</h2><p>Academy is awarded the Brown University contract as well as the Boston University shuttle contract.<br><br>ACQUISITION: NEW WORLD TOURS</p>'
    },
    {
        year: '2012',
        content: '<h2>2012</h2><p>ACQUISITIONS: GOLDEN (BALTIMORE), ENTERTAINMENT TOURS IN BOSTON, MA.</p>'
    },
    {
        year: '2013',
        content: '<h2>2013</h2><p>Academy Bus opens up its office in Chicago, IL.<br><br>Academy is awarded the Super Bowl XLVII contract at MetLife Stadium.ACQUISITIONS: CONWAY TOURS (RI), ATLANTIC EXPRESS (NYC).</p>'
    },
    {
        year: '2014',
        content: '<h2>2014</h2><p>Academy establishes itself in the state of Florida in Miami, West Palm Beach and Jacksonville.<br><br>Academy is awarded the UMass contract and an MTA contract in Baltimore.<br><br>ACQUISITIONS: HORIZON (FL), GO BUS (NYC).</p>'
    },
    {
        year: '2015',
        content: '<h2>2015</h2><p>Academy begins operating in Clearwater, FL, Capitol Heights, MD and Raleigh-Durham, NC.<br><br>Academy is awarded a commuter route inDC and opens a NEW Baltimore terminal.<br><br>ACQUISITIONS: HORIZON (NC), ENDEAVOR TOURS (MIAMI), FIRST PRIORITY (TAMPA), TREMBLAY COACH (RI).</p>'
    }
];

var app = {
    Urls: {
        SubmitEnqiure: "/Page/SubmitContact"
    },

    init() {
        this.Global.init();
        this.Header.init();
        this.Pages.init();
        this.Footer.init();
    },

    Global: {
        init() {
            this.Tabs.init();
        },

        Tabs: {
            init() {
                this.onTabClick();
                this.onWindowResize();
            },

            deactivate() {
                $('.tab__header.active').removeClass('active');
            },

            getActiveTabIndex() {
                var tabs = $('.tabs .tab__header'),
                    idx;

                tabs.each(tab => { if ($(tabs[tab]).hasClass('active')) idx = tab });
                return idx;
            },

            onTabClick() {
                $('.tab__header').on('click', e => {
                    var tab = $(e.currentTarget).attr('data-tab');

                    if ($(e.currentTarget).hasClass('active') && $(window).width() < 768) {
                        app.Global.Tabs.deactivate();
                    } else {
                        app.Global.Tabs.deactivate();
                        app.Header.defineActiveTabBasedOnURL('#' + tab);
                    }
                });
            },

            onWindowResize() {
                $(window).on('resize', () => {
                    if ($(window).width() > 767 && $('.tab__header.active').length < 1) {
                        !$('.tab__header:first').hasClass('.active') && $('.tab__header:first').addClass('.active');
                    }
                });
            }
        }
    },

    Header: {
        init() {
            this.handleBurgerMenuClick();
            this.handleDarkScreenClick();
            this.handleLinkHover();
            this.Menu.highlightCurrentPage();
            this.toggleDropdown();
        },

        defineActiveTabBasedOnURL(currPath) {
            console.log(currPath);
            if ($('.tab__header').length > 0) {
                var tab = currPath.includes('#') ? currPath.split('#')[1].replace(/\s/, '') : '',
                    tabTgt;

                //in case whitespace is included in url
                if (tab.includes('%'))
                    tab = tab.split('%')[0];

                if (tab.length > 0) {
                    $('.tab__header').each(x => {
                        let tabNameClean = $($('.tab__header')[x]).attr('data-tab').replace(/\s/, '');
                        if (tabNameClean === tab)                         
                            tabTgt = $($('.tab__header')[x]);
                        else
                            $($('.tab__header')[x]).removeClass('active');
                    });
                } else if ($('.tabs').length > 0) {
                    tabTgt = $($('.tab__header')[0]);
                }

                tabTgt.addClass('active');
                window.history.pushState(null, null, '#' + tabTgt.attr('data-tab').replace(/\s/, ''));
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        },

        handleBurgerMenuClick() {
            $('#burgerMenu').on('click', () => {
                $('#header').hasClass('active') ? app.Header.Menu.close() : app.Header.Menu.open();
            });
        },

        handleDarkScreenClick() {
            $('#header').on('click', '#darkScreen', () => {
                app.Header.Menu.close();
            });
        },

        handleLinkHover() {
            $('#headerMenu a').on('mouseenter', e => {
                $(e.currentTarget).siblings('a').addClass('reduced');
                $(e.currentTarget).addClass('expanded');
            }).on('mouseleave', () => {
                $('#headerMenu a').removeClass('reduced expanded');
            });
        },

        Menu: {
            close() {
                $('#darkScreen').remove();
                $('#header').removeClass('active');
            },

            highlightCurrentPage() {
                var currPath = window.location.href.split('/'),
                    links = $('#headerMenu a');

                for (var x = 0; x < currPath.length; x++) {
                    var currPathClean = currPath[currPath.length - 1].split('#')[0];

                    links.each(link => {
                        var linkText = links[link].text.toLowerCase();

                        if (linkText === 'about' && currPathClean === 'company' || linkText === currPathClean) {
                            $(links[link]).addClass('active');
                        }
                    });
                }
                app.Header.defineActiveTabBasedOnURL(currPath[currPath.length - 1]);
            },

            open() {
                $('#header').append('<div id="darkScreen" class="dark-screen"></div>');
                $('#header').addClass('active');
            }
        },

        toggleDropdown() {
            $('#header nav button').on('click', () => {
                $('#header nav button').toggleClass('active');
            });
        }
    },
    Footer: {
        init() {
            this.onTabLinkClick();
        },

        onTabLinkClick() {
            $('#footer .tab-link').on('click', e => {
                window.history.pushState(null, null, '/' + $(e.currentTarget).attr('data-tab'));
                window.location.reload();
            });
        }
    },
    Pages: {
        init() {
            $('.page').hasClass('faq') && this.FAQs.init();
            $('.page').hasClass('about') && this.History.init();
            $('.page').hasClass('home') && this.Home.init();
            if ($('.page').hasClass('news')) {
                this.Contact.init();
                this.Images.init();
                this.News.init();
            }
        },

        FAQs: {
            init() {
                this.togglePanelOnClick();
            },

            togglePanelOnClick() {
                $('.panel__header').on('click', e => {
                    var panel = $(e.currentTarget).closest('.panel'),
                        panelIsOpen = panel.hasClass('active');

                    if (panel.hasClass('main')) {
                        $('.panel').removeClass('active');
                        !panelIsOpen && panel.addClass('active');
                    } else {
                        if (panelIsOpen) {
                            panel.removeClass('active');
                        } else {
                            panel.siblings('.panel').removeClass('active');
                            panel.addClass('active');
                        }
                    }
                });
            }
        },

        History: {
            init() {
                $(document).ready(() => { app.Pages.History.moveBusToMarker() });
                this.generateTimeline();
                this.onPrevNextClick();
                this.onTimelineMarkerClick();
            },

            clearAllMarkerClasses() {
                $('#timeline li').attr('class', '');
            },

            displayTimelineYearContent(marker) {
                $('.timeline__body__content').html(
                    '<img src="images/pages/about/' + marker.year + '.png">' +
                    '<div>' + marker.content + '</div>'
                );
            },

            generateTimeline() {
                timeline.forEach(marker => {
                    var idx = timeline.indexOf(marker);

                    //generate header
                    idx % 2 === 0
                        ? $('.timeline__header').append('<li class="' + (idx === 0 ? 'active' : '') + '"><span class="date">' + marker.year + '</span><span class="marker"></span></li>')
                        : $('.timeline__header').append('<li><span class="marker"></span><span class="date">' + marker.year + '</span></li>');

                    //generate body
                    idx === 0 && app.Pages.History.displayTimelineYearContent(marker);
                });
            },

            moveBusToMarker() {
                var idx = $('#timeline li.active').index(),
                    wdwWidth = $(window).width(),
                    maxWidth = wdwWidth - 30,
                    distanceFirstMarker = 37
                distancePerMarker = 71,
                    requestedBusMove = distanceFirstMarker,
                    multiplier = 0;

                if (wdwWidth > 576 && wdwWidth < 768)
                    maxWidth = wdwWidth - 60;
                else if (wdwWidth > 767 && wdwWidth < 992)
                    maxWidth = wdwWidth - 200;
                else if (wdwWidth > 991 && wdwWidth < 1200)
                    maxWidth = wdwWidth - 260;
                else if (wdwWidth > 1199 && wdwWidth < 1400)
                    maxWidth = wdwWidth - 400;
                else if (wdwWidth > 1399)
                    maxWidth = 1000;

                var lastStaticMarkerIdx = Math.floor((maxWidth - distanceFirstMarker) / distancePerMarker) - 1;

                if (idx > lastStaticMarkerIdx) {
                    var timelineSlide = (idx - lastStaticMarkerIdx) * distancePerMarker;
                    multiplier = lastStaticMarkerIdx;
                    $('.timeline__header').css('left', -timelineSlide + 'px');
                } else {
                    multiplier = idx;
                    $('.timeline__header').css('left', '0px');
                }
                requestedBusMove += multiplier * distancePerMarker;
                $('#bus').css('left', requestedBusMove + 'px');
            },

            onPrevNextClick() {
                $('.btn--timeline').on('click', e => {
                    var tgtMarkerIdx = $('.timeline__header li.active').index(),
                        newMarkerIdx = tgtMarkerIdx;

                    if ($(e.currentTarget).hasClass('next') && tgtMarkerIdx + 1 < timeline.length)
                        newMarkerIdx++;
                    else if ($(e.currentTarget).hasClass('prev') && !tgtMarkerIdx - 1 < 0)
                        newMarkerIdx--;

                    app.Pages.History.updateTimeline($($('#timeline li')[newMarkerIdx]), newMarkerIdx);
                });
            },

            onTimelineMarkerClick() {
                $('#timeline').on('click', 'li', e => {
                    //console.log($(e.currentTarget).index())
                    app.Pages.History.updateTimeline($(e.currentTarget), $(e.currentTarget).index());
                });
            },

            updateTimeline(marker, idx) {
                app.Pages.History.clearAllMarkerClasses();
                marker.addClass('active');
                for (var x = 0; x < idx; x++) {
                    $($('#timeline li')[x]).addClass('visited');
                }
                app.Pages.History.moveBusToMarker();
                app.Pages.History.displayTimelineYearContent(timeline[idx]);
            }
        },

        Home: {
            init() {
                this.CompanyLinks.init();
            },

            CompanyLinks: {
                init() {
                    this.animateLinkOnHover();
                    this.removePanelOnCrossClick();
                },

                animateLinkOnHover() {
                    $('.home__company-links .link').on('mouseenter', e => {
                        $(e.currentTarget).siblings('.link').removeClass('active');
                        app.Pages.Home.CompanyLinks.open($(e.currentTarget));
                    });
                },

                close() {
                    $('.home__company-links .link').removeClass('active');
                    $('#homeCompanyLinksPanel').remove();
                },

                open(link) {
                    var data, col;

                    businesses.forEach(el => {
                        if (el.type === link.attr('data-target')) {
                            data = el.data;
                            col = el.data.colors;
                        }
                    });

                    app.Pages.Home.CompanyLinks.close();
                    link.siblings('.link').removeClass('reduced');
                    link.removeClass('expanded').addClass('active');
                    $(window).width() > 767 ? $('.home__company-links .area').append(app.Pages.Home.CompanyLinks.panelGenerate(data, col)) : link.after(app.Pages.Home.CompanyLinks.panelGenerate(data, col));
                },

                panelGenerate(data, col) {
                    var internalURL = data.website === 'www.academybus.com/commuter',
                        targetURL = internalURL ? '/commuter' : 'https://' + data.website,
                        newTab = internalURL ? '' : 'target="_blank"';

                    return (
                        '<div id="homeCompanyLinksPanel" class="home__company-links__panel flexbox same-height wrap" style="background: ' + col.primary + ';">' +
                            '<button class="cross white" type="button">' +
                                '<span></span>' +
                                '<span></span>' +
                            '</button>' +
                            '<div class="panel-logo flexbox center middle" style="background: ' + col.secondary + ';">' +
                                '<img src="images/logos/' + data.image + '" alt="' + data.alt + '">' +
                            '</div>' +
                            '<div class="panel-info flexbox middle">' +
                                '<div>' +
                                    '<p style="color: ' + col.text + '">' +
                                        data.html +
                                        '<br><br>' +
                                        '<b>Website</b>' +
                                        '<a class="flexbox left middle" href="' + targetURL + '" ' + newTab + ' style="color: ' + col.text + '">' +
                                            '<span class="text">' + data.website + '</span>' +
                                            '<span class="arrow arrow--right">' +
                                                '<span style="background: ' + col.arrow + ';"></span>' +
                                                '<span style="background: ' + col.arrow + ';"></span>' +
                                                '<span style="background: ' + col.arrow + ';"></span>' +
                                            '</span>' +
                                        '</a>' +
                                        (
                                            data.alt.toLowerCase() === 'academy bus'
                                                ?   '<br><b>Silverpass App</b>' +
                                                    '<a class="flexbox left middle" href="/commuter#app-fares-tickets" style="color: ' + col.text + '">' +
                                                        '<span class="text">The NEW Commuter Mobile Ticketing, Bus Tracking App</span>' +
                                                        '<span class="arrow arrow--right">' +
                                                            '<span style="background: ' + col.arrow + ';"></span>' +
                                                            '<span style="background: ' + col.arrow + ';"></span>' +
                                                            '<span style="background: ' + col.arrow + ';"></span>' +
                                                        '</span>' +
                                                    '</a>' +
                                                    '<br><b>Academy Bus in the News</b>' +
                                                    '<a class="flexbox left middle" href="/news/details/academy-bus-in-the-news" style="color: ' + col.text + '">' +
                                                        '<span class="text">Watch the video</span>' +
                                                        '<span class="arrow arrow--right">' +
                                                            '<span style="background: ' + col.arrow + ';"></span>' +
                                                            '<span style="background: ' + col.arrow + ';"></span>' +
                                                            '<span style="background: ' + col.arrow + ';"></span>' +
                                                        '</span>' +
                                                    '</a>'
                                                : ''
                                        ) +
                                        (
                                            data.alt.toLowerCase() === 'academy charter bus'
                                                ?   '<a class="flexbox left middle" href="http://sports.academybuscharter.com/" target="_blank" style="color: ' + col.text + '">' +
                                                        '<span class="text">www.sports.academybuscharter.com</span>' +
                                                        '<span class="arrow arrow--right">' +
                                                            '<span style="background: ' + col.arrow + ';"></span>' +
                                                            '<span style="background: ' + col.arrow + ';"></span>' +
                                                            '<span style="background: ' + col.arrow + ';"></span>' +
                                                        '</span>' +
                                                    '</a>' + 
                                                    '<a class="flexbox left middle" href="https://www.academybuscharter.com/shuttle-service/" target="_blank" style="color: ' + col.text + '">' +
                                                        '<span class="text">www.academybuscharter.com/shuttle-service</span>' +
                                                        '<span class="arrow arrow--right">' +
                                                            '<span style="background: ' + col.arrow + ';"></span>' +
                                                            '<span style="background: ' + col.arrow + ';"></span>' +
                                                            '<span style="background: ' + col.arrow + ';"></span>' +
                                                        '</span>' +
                                                    '</a>'
                                                : ''
                                        ) +
                                    '</p>' +
                                '</div>' +
                            '</div>' +
                        '</div>'
                    )
                },

                removePanelOnCrossClick() {
                    $('.home__company-links').on('click', '.cross', () => { app.Pages.Home.CompanyLinks.close() });
                }
            }
        },

        Images: {
            init() {
                this.assignImagesArray();
                this.closeImgHighlightingOnCrossClick();
                this.displayViewScreenOnThumbnailHover();
                this.handlePrevNextImgOnClick();
                this.highlightImgOnSelection();
            },

            assignImagesArray() {
                let thumbs = $('.images .thumbnail');
                thumbs.each(el => { images.push($(thumbs[el]).attr('data-src')) });
            },

            closeImgHighlightingOnCrossClick() {
                $('#imagesBtnClose').on('click', () => {
                    $('.images').removeClass('zoom-in');
                    $('#selectedImg').attr('src', '');
                });
            },

            displayViewScreenOnThumbnailHover() {
                $('.images').on('mouseenter', '.thumbnail:not(.highlighted)', e => {
                    $(e.currentTarget).append(
                        '<div id="thumbnailScreen" class="thumbnail-screen flexbox center middle">' +
                        '<p>VIEW</p>' +
                        '</div>'
                    );
                }).on('mouseleave', '.thumbnail:not(.highlighted)', () => {
                    $('#thumbnailScreen').remove();
                });
            },

            handlePrevNextImgOnClick() {
                $('.btn--slide').on('click', e => {
                    let currSRC = $('#selectedImg').attr('src'),
                        btnDir = $(e.currentTarget).hasClass('images__btn--next') ? 'up' : 'down',
                        tgtImgIdx = 0;

                    images.forEach(el => {
                        if (currSRC === el) {
                            let currImgIdx = images.indexOf(el);

                            if (btnDir === 'up') {
                                if (images.length > currImgIdx + 1)
                                    tgtImgIdx = currImgIdx + 1;
                                else
                                    tgtImgIdx = 0;
                            } else {
                                if (currImgIdx - 1 < 0)
                                    tgtImgIdx = images.length - 1;
                                else
                                    tgtImgIdx = currImgIdx - 1;
                            }

                        }
                    });
                    $('#selectedImg').attr('src', images[tgtImgIdx]);
                });
            },

            highlightImgOnSelection() {
                $('.images').on('click', '.thumbnail', e => {
                    var imgSRC = $(e.currentTarget).attr('data-src');

                    $('#thumbnailScreen').remove();
                    $(e.currentTarget).closest('.images').addClass('zoom-in');
                    $('#selectedImg').attr('src', imgSRC);
                });
            }
        },

        News: {
            init() {
                this.createArticleExcerpt();
                this.handleArticleHover();
            },

            createArticleExcerpt() {
                if ($('#page.news').length > 0) {
                    var articles = $('.releases .article__excerpt');

                    articles.each(idx => {
                        var excerpt = $(articles[idx]).text();
                        excerpt.length > 200 && $(articles[idx]).text(excerpt.slice(0, 200) + '...');
                    });
                }
            },

            handleArticleHover() {
                $('.home__news article').on('mouseenter', e => {
                    $('.home__news .area > .flexbox').addClass('hover-' + $(e.currentTarget).index());
                }).on('mouseleave', () => {
                    $('.home__news .area > .flexbox').attr('class', 'flexbox between top wrap');
                });
            }
        },

        Contact: {
            init: function () {
                //console.log('mmsystem.ui.content.Pages.Contact.init ...');
                //If Form exist
                //console.log(app.Pages.Contact.DomElements.Form.GetContactForm().length > 0);
                if (app.Pages.Contact.DomElements.Form.GetContactForm().length > 0) {
                    this.AddEventListers();
                    app.FormValidation.Validation.Init(app.Pages.Contact.DomElements.Form.GetContactForm(), app.FormValidation.Validation.Rules.ContactFormRules);
                }

            },

            AddEventListers: function () {
                //console.log('AddEventListers ...');
                //Submit Enquire
                app.Pages.Contact.DomElements.SubmitEnquireButton().click(function (e) {
                    e.preventDefault();
                    if (app.FormValidation.Validation.Form.valid()) {
                        //console.log('send enquire');
                        var data = app.Pages.Contact.DomElements.Form.GetContactData();
                        //console.log(data);
                        mmsystem.ui.ajax.SubmitEnquire(app.Urls.SubmitEnqiure, data);
                        mmsystem.plugins.AjaxCover.ShowOnButton($(this).attr('id'));
                    }
                });

                mmsystem.ui.ajax.EventEmitter.on('submitEnquireComplete', function (param) {
                    //console.log('mmsystem.ui.ajax.EventEmitter: submitEnquireComplete');
                    var result = param.responseJSON;
                    if (result && result.Type == 1) {
                        app.Pages.Contact.DomElements.SubmitEnquireButton().attr("disabled", "disabled");
                        $('.equire-response-message').removeClass('d-none').addClass('text-success').text('success');
                        app.Pages.Contact.DomElements.Form.GetContactForm().hide();
                    }

                    if (result && result.Message)
                        $('.equire-response-message').text(result.Message);

                    mmsystem.plugins.AjaxCover.Hide();

                });

                //Server Error
                mmsystem.ui.ajax.EventEmitter.on("serverError", function (e, param) {
                    //console.log('Server Error');
                    mmsystem.plugins.AjaxCover.Hide();
                    $('.equire-response-message').removeClass('d-none').addClass('text-danger').text('sending failed, please try again');
                });
            },

            DomElements: {
                SubmitEnquireButton: function () {
                    return $('#send-enquiry');
                },

                Form: {
                    GetById: function (id) {
                        return $('form#' + id);
                    },

                    GetContactForm: function () {
                        return this.GetById('form-contact');
                    },

                    GetContactFormElement: function () {
                        return $('.form--contact-info');
                    },
                    ContactTypeId: function () {
                        return $('#contact-type-id');
                    },
                    Email: function () {
                        return $('#userEmail');
                    },
                    FirstName: function () {
                        return $('#userFName');
                    },
                    LastName: function () {
                        return $('#userLName');
                    },
                    PhoneNumber: function () {
                        return $('#userTel');
                    },
                    FaxNumber: function () {
                        return $('#userFax');
                    },
                    Address1: function () {
                        return $('#userAddress1');
                    },
                    Address2: function () {
                        return $('#userAddress2');
                    },
                    City: function () {
                        return $('#userCity');
                    },
                    Zipcode: function () {
                        return $('#userZip');
                    },
                    State: function () {
                        return $('#userState');
                    },
                    Department: function () {
                        return $('#userDepartment');
                    },
                    Source: function () {
                        return $('#userSource');
                    },
                    Message: function () {
                        return $('#userComments');
                    },
                    NotificationsAgreement: function () {
                        return $('#userNotificationsAgreement');
                    },
                    GetContactData: function () {
                        var data = {
                            ContactTypeId: app.Pages.Contact.DomElements.Form.ContactTypeId().val(),
                            FirstName: app.Pages.Contact.DomElements.Form.FirstName().val(),
                            LastName: app.Pages.Contact.DomElements.Form.LastName().val(),
                            Email: app.Pages.Contact.DomElements.Form.Email().val(),
                            PhoneNumber: app.Pages.Contact.DomElements.Form.PhoneNumber().val(),
                            FaxNumber: app.Pages.Contact.DomElements.Form.FaxNumber().val(),
                            Address1: app.Pages.Contact.DomElements.Form.Address1().val(),
                            Address2: app.Pages.Contact.DomElements.Form.Address2().val(),
                            City: app.Pages.Contact.DomElements.Form.City().val(),
                            Zipcode: app.Pages.Contact.DomElements.Form.Zipcode().val(),
                            State: app.Pages.Contact.DomElements.Form.State().val(),
                            Department: app.Pages.Contact.DomElements.Form.Department().val(),
                            Source: app.Pages.Contact.DomElements.Form.Source().val(),
                            Message: app.Pages.Contact.DomElements.Form.Message().val(),
                            NotificationsAgreement: app.Pages.Contact.DomElements.Form.NotificationsAgreement().val()
                        }

                        return data;
                    }
                }
            }
        },
    },

    FormValidation: {
        init() {
            //this.Validation.init();
        },

        Validation: {
            Form: {},
            Validator: {},

            Init: function (form, rules) {
                this.Form = form;
                this.Validator = form.validate();

                //console.log(this.Validator);
                //console.log(this.Form);

                //Setup rules
                if (rules)
                    this.Validator.settings.rules = rules;
            },

            ClearRules: function () {
                //console.log(this.Validator);
                this.Validator.settings.rules = {};
            },

            SetRules: function (rules) {
                //console.log(this.Validator);
                this.Validator.settings.rules = rules;
            },

            AppendRules: function (rules) {
                this.Validator.settings.rules.push(rules);
            },

            Rules: {
                EmailRules: {
                    email: {
                        required: true,
                        email: true
                    }
                },
                PolicyRules: {
                    dataAgree: {
                        required: true
                    }
                },

                ContactFormRules: {
                    userEmail: { required: true, email: true },
                    userPhone: { required: true },
                    userComments: { required: true },
                    userFName: { required: true },
                    userLName: { required: true },
                    userFax: { required: true },
                    userAddress1: { required: true },
                    userAddress2: { required: true },
                    userCity: { required: true },
                    userZip: { required: true },
                    userState: { required: true },
                    userDepartment: { required: true },
                    userSource: { required: true },
                    userNotificationsAgreement: { required: true }
                },
                //GetCheckoutRules: function () { return Object.assign(mmsystem.ui.content.orders.Validation.Rules.EmailRules, mmsystem.ui.content.orders.Validation.Rules.PolicyRules) },
            }
        }
    }
};

$(document).ready(function () { app.init() });